export enum ChefForPartyBookingTypeEnum {
    CHEF_FOR_PARTY = "CHEF_FOR_PARTY",
    BOOK_BY_DISH = "BOOK_BY_DISH",
}

export const ChefForPartyBookingTypeLabels: Record<ChefForPartyBookingTypeEnum, string> = {
    [ChefForPartyBookingTypeEnum.CHEF_FOR_PARTY]: "Chef for Party",
    [ChefForPartyBookingTypeEnum.BOOK_BY_DISH]: "Book by Dish",
};
